export default __webpack_public_path__ + "static/media/02.9485e6be.jpg";